
import { get ,post} from "../services/HttpService";

export class CbdtApiService {
    static validations = {};

    static getUnionCustomerDetails = (queryData = {}, config = {}) => {
        return get(`tax/union_bank/customer_details/`, queryData, config).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };

    static getUnionCustomerDetails_form = (queryData = {}, config = {}) => {
        return get(`tax/union_bank/customer_details/form`, queryData, config).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };

    static pay = (queryData = {}, config = {}) => {
        return post(`tax/union_bank/pay/`, queryData, config).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };
}